
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModalHeader extends Vue {
    @Prop({ default: '', type: String }) readonly title!: string;

    @Prop({ default: false, type: Boolean })
    readonly closeDisabled!: boolean;
}
